module.exports = __webpack_public_path__ + "media/images/notes-cb9736b1b4870cd8e25cc85898a442a9.png";